import { z } from 'zod';
import { PaginationInputSchema, SortBySchema } from '../../common';
import { BadgeTypes, LockedOutFilter } from '../../../entities/user/enums';

export const AdminEditUserInputSchema = z.object({
    id: z.string(),
    isLockedOut: z.boolean().optional(),
    isInStudy: z.boolean().optional(),
});

export const GetUsersPageInputSchema = PaginationInputSchema.extend({
    sort: SortBySchema,
    searchString: z.string().optional(),
    lockedOutFilter: z.nativeEnum(LockedOutFilter).optional(),
});

export const AdminDeleteUserInputSchema = z.object({
    id: z.string(),
});

export const AdminGivePrizeWinnerBadgeSchema = z.object({
    id: z.string(),
    badgeType: z.enum([BadgeTypes.prizeWinner, BadgeTypes.miniGameWinner]),
});

export const AdminAddPointsSchema = z.object({
    userId: z.string(),
    amount: z.number().int().positive(),
    addBadge: z.boolean().optional(),
});
